import { auth } from "../firebase"; // Import Firebase authentication and Firestore instance
import { db } from "../firebase"; // Adjust the import path for db
import { useNavigate } from "react-router-dom";
import { addDoc, collection } from "firebase/firestore"; // Import necessary Firestore functions
import React, { useState } from "react";
import { Button, Row, Form, Col } from "react-bootstrap";
import {
  createUserWithEmailAndPassword,
  onAuthStateChanged,
  signOut,
  updateProfile,
} from "firebase/auth";
import AppToast from "./Toast";
import { InputMask } from "primereact/inputmask";
import { motion, AnimatePresence } from "framer-motion";
import { ButtonBase } from "@mui/material";

function Registration1({
  user,
  setUser,
  artist,
  setArtist,
  member,
  setMember,
}) {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [role, setRole] = useState(null);

  const [artistData, setArtistData] = useState({
    authRegID: "",
    first_name: "",
    last_name: "",
    email: "",
    phone: "",
    website: "",
    facebook: "",
    instagram: "",
    bio: "",
    role: "",
    agreed: "",
  });

  let userUid = "123-456-789-init"; // Define it in a higher scope

  // Handles the Buttons
  const handleRoleChange = (newRole) => {
    console.log("ROLE IS :", newRole);
    if (newRole === "guestArtist") {
      setArtist(true);
      setMember(false);
    } else {
      setArtist(false);
      setMember(true);
    }
    setRole(newRole);
    console.log("new Button interface Role is:", role);
    sessionStorage.setItem("role", "role");
    const myAgree = localStorage.getItem("agreed");
    console.log("The agree status is", myAgree);
  };

  // Collects from the form puts in artistsData
  const handleChange = (e, userUid) => {
    const { name, value } = e.target;
    setArtistData((prevData) => ({
      ...prevData,
      [name]: value,
      authRegID: userUid, // Include the authRegID from the parameter
      email: email,
      role: role,
      agreed: "true",
    }));
  };

  function formatPhoneNumber(input) {
    if (!input) {
      return ""; // Handle empty input
    }

    // Remove any non-numeric characters
    const cleanedValue = input.replace(/\D/g, "");

    // Format the phone number as "xxx-xxx-xxxx"
    let formattedValue = "";
    for (let i = 0; i < cleanedValue.length; i++) {
      if (i === 3 || i === 6) {
        formattedValue += "-";
      }
      formattedValue += cleanedValue.charAt(i);
    }

    return formattedValue;
  }

  onAuthStateChanged(auth, (currentUser) => {
    setUser(currentUser);
    console.table(currentUser);
    if (currentUser) {
      userUid = currentUser.uid;
      const email = userUid.email;
      console.log("Email is", email);

      if (role === "member") {
        console.log("This sets that you are a member");
        //navigate("/ArtistsList");
      } else {
        console.log("No All Artists Page");
      }
      console.log("Role variable is Role=", role);
    } else {
      //console.log("From AuthStateChange else There's no Uid");
      //console.log("Role variable is Role=", role);
    }
  });

  const handleRegistration = async () => {
    if (password !== confirmPassword) {
      // Show a toast notification or error message here
      console.error("Passwords do not match");
      return;
    }

    let userUid; // Declare userUid

    try {
      // Create a new user with email and password using Firebase authentication
      const userCred = await createUserWithEmailAndPassword(
        auth,
        email,
        password
      );

      // Update userUid with the actual user UID
      userUid = userCred.user.uid;

      // Update authRegID in the state with the updated userUid
      setArtistData((prevData) => ({
        ...prevData,
        authRegID: userUid,
        role: role,
        agreed: true, // Convert to boolean
      }));

      console.log("After createUserWithEmailAndPassword() ROLE is", role);
    } catch (error) {
      console.error("Firebase Error:", error.code, error.message);
      // Show an error message to the user
      alert(`Sorry: ${error.message}`);
    }
  };

  // add the addional info (first and last name, phone and website)
  // creates folder using first and last name in the following
  // format  Harry_Martin (images are stored there)
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      //assemble the string for the folder
      const dataToStore = artistData.first_name + "_" + artistData.last_name;
      //this acts like a session variable
      sessionStorage.setItem(
        "sessionFullName",
        artistData.first_name + " " + artistData.last_name
      );
      sessionStorage.setItem("email", artistData.email);
      sessionStorage.setItem("firstName", artistData.first_name);
      localStorage.setItem("fullName", dataToStore);
      //get the collection called 'artists'
      const artistsCollectionRef = collection(db, "artists");
      await addDoc(artistsCollectionRef, artistData);
      console.log("Document added to collection.");
      // Assuming artistData is available in this scope
      //updateDisplayNameIfNecessary(artistData.first_name, currentUser);
      //hide or switch to the upload component
      {
        !member && navigate("/TermsConditions");
      }
      {
        member && navigate("/EditUserProfile");
      }
    } catch (error) {
      alert("Sorry: ", error);
      return;
    }
  };

  const handleSignOut = async () => {
    await signOut(auth);
  };

  return (
    <>
      <Row id='artistsForm' className='image-container-dk mb-5 modal-content'>
        <Col lg={"12"}>
          <h1>Register</h1>
        </Col>
        {user && (
          <Form>
            <Row md={"12"} className='register-box'>
              <h4>
                I am registering as a
                {role === "guestArtist"
                  ? " Guest Artist"
                  : role === "member"
                  ? " Member"
                  : ""}
              </h4>
              {/* Choice Buttons */}
              {!role && (
                <>
                  <Col md={"6"}>
                    <Button
                      className='btn btn-primary'
                      variant={
                        role === "guestArtist" ? "primary" : "outline-primary"
                      }
                      onClick={() => handleRoleChange("guestArtist")}>
                      Guest Artist
                    </Button>
                  </Col>

                  <Col md={"6"}>
                    <Button
                      className='btn btn-primary'
                      variant={
                        role === "member" ? "primary" : "outline-primary"
                      }
                      onClick={() => handleRoleChange("member")}>
                      Member of PFG
                    </Button>
                  </Col>
                </>
              )}
            </Row>{" "}
          </Form>
        )}
        <div>
          {!user && (
            <div className='mb-3'>
              <label htmlFor='email' className='form-label'>
                Email:
              </label>
              <input
                type='email'
                className='form-control'
                id='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
          )}

          {!user && (
            <div className='mb-3'>
              <label htmlFor='password' className='form-label'>
                Password:
              </label>
              <input
                type='password'
                className='form-control'
                id='password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
            </div>
          )}
          {!user && (
            <div className='mb-3'>
              <label htmlFor='confirmPassword' className='form-label'>
                Re-enter Password:
              </label>
              {error && (
                <p style={{ color: "red" }}>{error}-please try again!</p>
              )}
              <input
                type='password'
                className='form-control'
                id='confirmPassword'
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </div>
          )}
        </div>
        {/* motion dov */}

        <div>
          <div className='mb-3'></div>
          {/* for artists and NOT members */}
          {user && role && (
            <div className='mb-3'>
              <label htmlFor='first_name' className='form-label'>
                First Name:
              </label>
              <input
                id='first_name'
                type='text'
                className='form-control'
                name='first_name'
                value={artistData.first_name}
                onChange={(e) => handleChange(e, userUid)}
                //onChange={handleChange}
                required
              />
            </div>
          )}

          {user && role && (
            <div className='mb-3'>
              <label htmlFor='last_name' className='form-label'>
                Last Name:
              </label>
              <input
                type='text'
                className='form-control'
                name='last_name'
                value={artistData.last_name}
                onChange={(e) => handleChange(e, userUid)}
                //onChange={handleChange}
                required
              />
            </div>
          )}

          {user && role && (
            <div className='mb-3'>
              <label htmlFor='phone' className='form-label'>
                Mobile Phone:
              </label>

              <InputMask
                type='text' // Use type 'text' for phone number input
                name='phone'
                className='form-control'
                value={artistData.phone}
                onChange={(e) => handleChange(e, userUid)}
                mask='999-999-9999'
                placeholder='212-555-1212'
              />
            </div>
          )}

          {user && role && (
            <div className='mb-3'>
              <label htmlFor='website' className='form-label'>
                Website:
              </label>
              <input
                type='text'
                name='website'
                className='form-control'
                value={artistData.website}
                onChange={(e) => handleChange(e, userUid)}
                //onChange={handleChange}
              />
            </div>
          )}

          {user && artist && (
            <div className='mb-3'>
              <label htmlFor='instagram' className='form-label'>
                Instagram:
              </label>
              <input
                type='text'
                name='instagram'
                className='form-control'
                value={artistData.instagram}
                onChange={(e) => handleChange(e, userUid)}
                //onChange={handleChange}
              />
            </div>
          )}

          {user && artist && (
            <div className='mb-3'>
              <label htmlFor='facebook' className='form-label'>
                Facebook:
              </label>
              <input
                type='text'
                name='facebook'
                className='form-control'
                value={artistData.facebook}
                onChange={(e) => handleChange(e, userUid)}
                //onChange={handleChange}
              />
            </div>
          )}

          {user && role && (
            <div className='mb-3'>
              <label htmlFor='bio' className='form-label'>
                Bio Info:
              </label>
              <textarea
                name='bio'
                value={artistData.bio}
                className='form-control'
                onChange={(e) => handleChange(e, userUid)}
                rows={4}
                style={{ width: "100%" }} // Set the width to 100%
                maxLength={600}
              />
              <p className='text-muted'>{artistData.description}</p>
            </div>
          )}

          <div>
            {!user && (
              <div className='align-items-baseline'>
                <Button
                  className='btn btn-primary mb-4'
                  onClick={handleRegistration}>
                  Continue...
                </Button>
              </div>
            )}
            {user && role && (
              <div>
                <Button className='mb-4 btn btn-default' onClick={handleSubmit}>
                  Next...
                </Button>
              </div>
            )}
          </div>
        </div>
        {/* motion div */}
      </Row>
    </>
  );
}

export default Registration1;
